module.exports = __webpack_public_path__ + "img/certificate2.d5861ce6.png";